import {useRoutesContext} from '../hooks/useRoutesContext'
import { useAuthContext } from '../hooks/useAuthContext'

const RouteDetails = ({route}) => {
    const {dispatch} = useRoutesContext()
    const {user} = useAuthContext()

    const likePost = async()=>{
        if(!user){
            return
        }
        const response = await fetch('https://wildroutes-api.onrender.com/api/routes/like/' + route._id, {
            method: 'PATCH',
            headers:{
                'Authorization': `Bearer ${user.token}`
            }
        })
        const json = await response.json()
        if(response.ok){
            dispatch({type: 'UPDATE_LIKES', payload: json})
            /*Reload is a temporary solution. Ideally, it would update without refreshing.*/
            window.location.reload(); 
        }
    }

    const unlikePost = async()=>{
        if(!user){
            return
        }

        const response = await fetch('https://wildroutes-api.onrender.com/api/routes/like/' + route._id, {
            method: 'DELETE',
            headers:{
                'Authorization': `Bearer ${user.token}`
            }
        })
        const json = await response.json()
        if(response.ok){
            dispatch({type: 'DELETE_ROUTE', payload: json})
            /*Reload is a temporary solution. Ideally, it would update without refreshing.*/
            //window.location.reload(); 
        }
    }

    const deletePost = async()=>{
        if(!user){
            return
        }

        const response = await fetch('https://wildroutes-api.onrender.com/api/routes/' + route._id, {
            method: 'DELETE',
            headers:{
                'Authorization': `Bearer ${user.token}`
            }
        })
        const json = await response.json()
        if(response.ok){
            dispatch({type: 'DELETE_ROUTE', payload: json})
            /*Reload is a temporary solution. Ideally, it would update without refreshing.*/
            //window.location.reload(); 
        }
    }

    return(
        <div id="route-details">
            <img id ="myImg" alt = "Cover" src={route.imageLink}></img>
            <h3>{route.noLikes} likes</h3>
            <h2>📍 {route.location}</h2>
            <h1>{route.title}</h1>
            <h4>{route.rating}</h4>
            <h5>Posted by {route.madeBy}</h5>
            <p>{route.description}</p>
            <div className="book">
                <form>
                    <button formAction={route.bookingLink}>Book</button>
                </form>
            </div>
            {route.likedBy.includes(user.idCode)
                ? 
                    <i className="material-symbols-outlined"onClick={unlikePost}> close </i>
                : 
                    <i className="material-symbols-outlined"onClick={likePost}>favorite</i>
            }
            {route.user_id === user.idCode 
                ? 
                <span className="material-symbols-outlined" onClick={deletePost}>delete</span>
                :
                    <span></span>
            }
            
        </div>
    )
}

/* <span className="material-symbols-outlined" onClick={handleClick}>favorite</span>
*/
export default RouteDetails